/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ChatConversation,
  ChatConversationWithMessages,
  CreateConversationRequest,
  DeleteChatConversation200Response,
  ErrorEnvelope,
  ListConversationsResponse,
  SendMessageRequest,
  SendMessageResponse,
} from '../models/index';
import {
    ChatConversationFromJSON,
    ChatConversationToJSON,
    ChatConversationWithMessagesFromJSON,
    ChatConversationWithMessagesToJSON,
    CreateConversationRequestFromJSON,
    CreateConversationRequestToJSON,
    DeleteChatConversation200ResponseFromJSON,
    DeleteChatConversation200ResponseToJSON,
    ErrorEnvelopeFromJSON,
    ErrorEnvelopeToJSON,
    ListConversationsResponseFromJSON,
    ListConversationsResponseToJSON,
    SendMessageRequestFromJSON,
    SendMessageRequestToJSON,
    SendMessageResponseFromJSON,
    SendMessageResponseToJSON,
} from '../models/index';

export interface CreateChatConversationRequest {
    createConversationRequest: CreateConversationRequest;
}

export interface DeleteChatConversationRequest {
    id: number;
}

export interface GetChatConversationRequest {
    id: number;
}

export interface GetChatConversationsRequest {
    page?: number;
    limit?: number;
}

export interface SendChatMessageRequest {
    id: number;
    sendMessageRequest: SendMessageRequest;
}

/**
 * ChatApi - interface
 * 
 * @export
 * @interface ChatApiInterface
 */
export interface ChatApiInterface {
    /**
     * 
     * @summary Create a new chat conversation
     * @param {CreateConversationRequest} createConversationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApiInterface
     */
    createChatConversationRaw(requestParameters: CreateChatConversationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChatConversation>>;

    /**
     * Create a new chat conversation
     */
    createChatConversation(requestParameters: CreateChatConversationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChatConversation>;

    /**
     * 
     * @summary Delete a conversation
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApiInterface
     */
    deleteChatConversationRaw(requestParameters: DeleteChatConversationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteChatConversation200Response>>;

    /**
     * Delete a conversation
     */
    deleteChatConversation(requestParameters: DeleteChatConversationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteChatConversation200Response>;

    /**
     * 
     * @summary Get conversation with messages
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApiInterface
     */
    getChatConversationRaw(requestParameters: GetChatConversationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChatConversationWithMessages>>;

    /**
     * Get conversation with messages
     */
    getChatConversation(requestParameters: GetChatConversationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChatConversationWithMessages>;

    /**
     * 
     * @summary Get user\'s chat conversations
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApiInterface
     */
    getChatConversationsRaw(requestParameters: GetChatConversationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListConversationsResponse>>;

    /**
     * Get user\'s chat conversations
     */
    getChatConversations(requestParameters: GetChatConversationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListConversationsResponse>;

    /**
     * 
     * @summary Send a message and get AI response
     * @param {number} id 
     * @param {SendMessageRequest} sendMessageRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatApiInterface
     */
    sendChatMessageRaw(requestParameters: SendChatMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SendMessageResponse>>;

    /**
     * Send a message and get AI response
     */
    sendChatMessage(requestParameters: SendChatMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SendMessageResponse>;

}

/**
 * 
 */
export class ChatApi extends runtime.BaseAPI implements ChatApiInterface {

    /**
     * Create a new chat conversation
     */
    async createChatConversationRaw(requestParameters: CreateChatConversationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChatConversation>> {
        if (requestParameters['createConversationRequest'] == null) {
            throw new runtime.RequiredError(
                'createConversationRequest',
                'Required parameter "createConversationRequest" was null or undefined when calling createChatConversation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/chat/conversations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateConversationRequestToJSON(requestParameters['createConversationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChatConversationFromJSON(jsonValue));
    }

    /**
     * Create a new chat conversation
     */
    async createChatConversation(requestParameters: CreateChatConversationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChatConversation> {
        const response = await this.createChatConversationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a conversation
     */
    async deleteChatConversationRaw(requestParameters: DeleteChatConversationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteChatConversation200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteChatConversation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/chat/conversations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteChatConversation200ResponseFromJSON(jsonValue));
    }

    /**
     * Delete a conversation
     */
    async deleteChatConversation(requestParameters: DeleteChatConversationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteChatConversation200Response> {
        const response = await this.deleteChatConversationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get conversation with messages
     */
    async getChatConversationRaw(requestParameters: GetChatConversationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChatConversationWithMessages>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getChatConversation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/chat/conversations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChatConversationWithMessagesFromJSON(jsonValue));
    }

    /**
     * Get conversation with messages
     */
    async getChatConversation(requestParameters: GetChatConversationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChatConversationWithMessages> {
        const response = await this.getChatConversationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get user\'s chat conversations
     */
    async getChatConversationsRaw(requestParameters: GetChatConversationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListConversationsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/chat/conversations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListConversationsResponseFromJSON(jsonValue));
    }

    /**
     * Get user\'s chat conversations
     */
    async getChatConversations(requestParameters: GetChatConversationsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListConversationsResponse> {
        const response = await this.getChatConversationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Send a message and get AI response
     */
    async sendChatMessageRaw(requestParameters: SendChatMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SendMessageResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling sendChatMessage().'
            );
        }

        if (requestParameters['sendMessageRequest'] == null) {
            throw new runtime.RequiredError(
                'sendMessageRequest',
                'Required parameter "sendMessageRequest" was null or undefined when calling sendChatMessage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/chat/conversations/{id}/messages`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendMessageRequestToJSON(requestParameters['sendMessageRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SendMessageResponseFromJSON(jsonValue));
    }

    /**
     * Send a message and get AI response
     */
    async sendChatMessage(requestParameters: SendChatMessageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SendMessageResponse> {
        const response = await this.sendChatMessageRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
